import { c as _c } from "react/compiler-runtime";
import type { CardNetApyVariant, NetApy } from '../CardNetApy';
import type { CardNetApyRowItemProps } from '../CardNetApyRowItem/CardNetApyRowItem';
import { CardNetApyRowItem } from '../CardNetApyRowItem';
export interface CardNetApyAggregatedRowsProps {
  apys: NetApy[];
  title: string;
  tooltipContent?: CardNetApyRowItemProps['tooltipContent'];
  variant: CardNetApyVariant;
}
const CardNetApyAggregatedRows = t0 => {
  const $ = _c(12);
  const {
    apys,
    title,
    tooltipContent,
    variant
  } = t0;
  let t1;
  if ($[0] !== title) {
    t1 = <div className="px-md h-lg flex items-center"><span className="text-2xs text-secondary-foreground">{title}</span></div>;
    $[0] = title;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== apys || $[3] !== tooltipContent || $[4] !== variant) {
    let t3;
    if ($[6] !== tooltipContent || $[7] !== variant) {
      t3 = (apy, index) => <CardNetApyRowItem key={`apy-${apy.name}-${index}`} index={index} apr={apy.apy} tooltipContent={tooltipContent} chainId={apy.chainId} logoURIs={apy.logoURIs} market={apy.market} allocation={apy.allocation} percentageOffset={apy.percentageOffset} weight={apy.weight} name={apy.name} hideAllocation={true} isVaultV2={apy.isVaultV2} maxRate={apy.maxRate} href={apy.href} hoverCardProps={apy.hoverCardProps} variant={variant} />;
      $[6] = tooltipContent;
      $[7] = variant;
      $[8] = t3;
    } else {
      t3 = $[8];
    }
    t2 = apys.map(t3);
    $[2] = apys;
    $[3] = tooltipContent;
    $[4] = variant;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[9] !== t1 || $[10] !== t2) {
    t3 = <div className="flex w-full flex-col">{t1}{t2}</div>;
    $[9] = t1;
    $[10] = t2;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  return t3;
};
export default CardNetApyAggregatedRows;